import { call, select } from 'redux-saga/effects';

import { wfs } from './endpoints';
import { API } from './api';

const getBaseConfig = ({ serverConfig }) => serverConfig;

export function* fetchWFS({
  typename,
  request,
  parcelId,
  propertyName,
  count,
  filter,
  geometry,
}) {
  const { namespace, version } = yield select(getBaseConfig);

  const path = wfs({
    namespace,
    version,
    typename,
    request,
    cql_filter: parcelId ? `parcel_id='${parcelId}'` : filter,
    propertyName,
    count,
    geometry,
  });

  const results = yield call(API, 'get', 'api', path);

  return results;
}
